import { action, atom, computed } from "@reatom/core"
import { molecule } from "bunshi"
import { BlockchainsMoleculeReatom } from "../blockchain-molecule.reatom"
import {
  type BlockchainFilter,
  BlockchainFiltersScope,
} from "./blockchain-filters-scope"

export const BlockchainFiltersMoleculeReatom = molecule((mol, scope) => {
  const { supportedBlockchains } = mol(BlockchainsMoleculeReatom)
  const { selectedBlockchain: initialSelectedBlockchain } = scope(
    BlockchainFiltersScope,
  )

  const selectedBlockchain = atom<BlockchainFilter>(
    initialSelectedBlockchain,
    "selectedBlockchain",
  )

  const blockchainsQueryFilter = computed(() => {
    const selected = selectedBlockchain()

    if (!selected || selected === "ALL") {
      return [...supportedBlockchains()]
    }
    return [selected]
  }, "blockchainsQueryFilter")

  const setSelectedBlockchain = action((newBlockchain: BlockchainFilter) => {
    if (newBlockchain === selectedBlockchain()) return
    selectedBlockchain.set(newBlockchain)
  }, "setSelectedBlockchain")

  return {
    selectedBlockchain,
    availableBlockchains: supportedBlockchains,
    blockchainsQueryFilter,
    setSelectedBlockchain,
  }
})
